export interface PopupRelations {
  productSlugs: string[];
  categorySlugs: string[];
  brandSlugs: string[];
}

export const popupRelationsFromResponse = (
  responseData: any,
): PopupRelations => ({
  productSlugs: responseData.product_slugs ?? [],
  categorySlugs: responseData.category_slugs ?? [],
  brandSlugs: responseData.brand_slugs ?? [],
});
